import React from 'react';
import { shape, string, node, number, bool } from 'prop-types';
import { getMeetupAttendeesByName, getMeetupTypesByName } from '@paddl/utils-js';
import { LogoCardWithText, MarkDownSection } from '../../../..';
import { DetailsWrapper } from '../../../Activity.styles';
import { getActivityDetailsBulletPoints } from '../../../../Utils/activities';
export const MeetupRead = _ref => {
  let {
    data: {
      details: {
        name,
        organiser: {
          icon: organiserIcon,
          name: organiserName
        },
        meetupLocation: {
          originalText: meetupLocation
        },
        description,
        commitmentHours,
        isVirtual,
        isHost,
        typeId,
        attendeesId
      }
    },
    editButton
  } = _ref;
  const tagRow1 = [];
  if (typeId) tagRow1.push(getMeetupTypesByName(typeId));
  if (attendeesId) tagRow1.push(getMeetupAttendeesByName(attendeesId));
  return /*#__PURE__*/React.createElement(DetailsWrapper, null, editButton, /*#__PURE__*/React.createElement("h1", {
    className: "headline"
  }, name), /*#__PURE__*/React.createElement(LogoCardWithText, {
    avatarUrl: organiserIcon,
    title: organiserName,
    ssubtitle: meetupLocation,
    isSubtitleShortened: true
  }), description ? /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(MarkDownSection, {
    markDown: description
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, "".concat(commitmentHours, " Hours")), /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, tagRow1.join(' • ')), /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, getActivityDetailsBulletPoints({
    virtual: isVirtual,
    host: isHost
  })));
};
MeetupRead.propTypes = {
  data: shape({
    details: shape({
      name: string,
      organiser: shape({
        icon: string,
        name: string
      }),
      meetupLocation: shape({
        originalText: string,
        shortText: string
      }),
      description: string,
      commitmentHours: number,
      isVirtual: bool,
      isHost: bool,
      typeId: number,
      attendeesId: number
    }).isRequired
  }).isRequired,
  editButton: node
};
MeetupRead.defaultProps = {
  editButton: undefined
};